import { render, staticRenderFns } from "./TerminationPage.vue?vue&type=template&id=d2e6456e&"
import script from "./TerminationPage.vue?vue&type=script&lang=js&"
export * from "./TerminationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports